import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ModelUrl } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

type State = {
    gltfPath: Nullable<ModelUrl>;
};

const initialState: State = {
    gltfPath: null,
};

const slice = createSlice({
    name: "model",
    initialState,
    reducers: {
        modelSetGltfAction: (state: State, action: PayloadAction<ModelUrl>) => {
            state.gltfPath = action.payload;
        },
    },
});

export const { modelSetGltfAction } = slice.actions;

export default slice.reducer;
